import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiComponent } from './ui.component';
import { SkeletonCommonModule } from './components/common/components/common.module';
import { ParagraphModule } from './components/paragraph/components/paragraph.module';
import { ImageModule } from './components/image/components/image.module';
import { BreadcrumbModule } from './components/breadcrumb/components/breadcrumb.module';
import { CardModule } from './components/card/components/card.module';
import { ChartModule } from './components/chart/components/chart.module';
import { TableModule } from './components/table/components/table.module';
import { ReportModule } from './components/document/components/report.module';
import { ListModule } from './components/list/components/list.module';
import { VideoModule } from './components/video/components/video.module';
import { GalleryModule } from './components/gallery/components/gallery.module';
import { ChatModule } from './components/chat/chat.module';
import { TestimonialModule } from './components/testimonial/components/testimonial.module';

@NgModule({
  declarations: [UiComponent],
  imports: [
    CommonModule,
    SkeletonCommonModule,
    ParagraphModule,
    ImageModule,
    BreadcrumbModule,
    CardModule,
    ChartModule,
    ReportModule,
    ListModule,
    ChartModule,
    TableModule,
    VideoModule,
    GalleryModule,
    ChatModule,
    TestimonialModule
  ],
  exports: [
    UiComponent,
    SkeletonCommonModule,
    ParagraphModule,
    ImageModule,
    BreadcrumbModule,
    CardModule,
    ChartModule,
    ReportModule,
    TableModule,
    ListModule,
    VideoModule,
    GalleryModule,
    ChatModule,
    TestimonialModule
  ]
})
export class NgxSkeletonSmartModule {}
